
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Permission,
  Role,
  RolePermission,
} from "@/script/apps/system/entity/SystemEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { AuthService } from "@/script/apps/system/service/AuthService";
import { ElMessage } from "element-plus";
import { Success } from "@/script/core/service/DataService";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { Category } from "@/script/apps/cms/entity/CmsEntity";
import { number } from "echarts";

@Options({})
export default class AuthDetail extends BaseDetail {
  private service = new AuthService();

  private permissions: Permission[] = [];
  private categorys: Category[] = [];
  private data1 = true;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "sys_auth",
      "/sys/auth",
      "/sys/auth",
      this.service
    );
    data.statesName = "sys-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Role = { permissionList: [] };
    return entity;
  }

  public load(id: number, success?: Success) {
    this.service.loadPermissionList((data: any) => {
      data.forEach((item: Permission) => {
        item.hasChildren = true;
        item.childPermissions.forEach((childItem: Permission) => {
          childItem.hasChildren = false;
        });
      });
      this.permissions = data;
      super.load(id, success);
    });
  }

  public afterLoad(data: any) {
    const role = data as Role;
    this.permissions.forEach((module: Permission) => {
      module.childPermissions.forEach((bill: Permission) => {
        bill.childPermissions.forEach((functionItem: Permission) => {
          functionItem.checked = this.hasPermission(role, functionItem.id!);
        });
        bill.checked = this.hasPermission(role, bill.id!);
      });
      module.checked = this.hasPermission(role, module.id!);
    });

    const categoryService = new CategoryService();
    categoryService.loadTreeCategorys((data: any) => {
      this.categorys = data;
      if (role.data1 === "0") {
        this.data1 = true;
        this.categorys.forEach((category) => {
          category.checked = false;
        });
      } else {
        this.data1 = false;
        const cids = role.data1!.split(",");
        this.categorys.forEach((category) => {
          cids.forEach((id) => {
            if (category.id === Number(id)) {
              category.checked = true;
            }
          });
        });
      }
    });
  }

  private hasPermission(role: Role, pid: number) {
    for (let i = 0; i < role.permissionList.length; i++) {
      if (role.permissionList[i].permissionId === pid) {
        return true;
      }
    }
    return false;
  }

  public beforeSave(): boolean {
    const role = this.entity as Role;
    role.permissionTemplateList = this.permissions;
    if (this.data1) {
      role.data1 = "0";
    } else {
      const ids: number[] = [];
      this.categorys.forEach((category) => {
        if (category.checked) {
          ids.push(category.id!);
        }
      });
      role.data1 = ids.join(",");
    }

    return true;
  }

  private checked(item: Permission) {
    if (item.code !== "load") {
      return;
    }
    this.permissions.forEach((module: Permission) => {
      let hasModule = false;
      module.childPermissions.forEach((bill: Permission) => {
        if (bill.id === item.parentId) {
          bill.checked = item.checked;
        }
        if (bill.checked) {
          hasModule = true;
        }
      });
      module.checked = hasModule;
    });
  }

  private dataChecked(item: any) {
    this.data1 = false;
  }

  private dataAllChecked() {
    if (this.data1) {
      this.categorys.forEach((category) => {
        category.checked = false;
      });
    }
  }
}
